<div class="d-flex">
  <app-tabs-form [activeForm]="activeForm" [account_type]="account_type" [draft]="draft"
    (changeForm)="changeForm($event)" [role]="role" [updatesTabs]="updatesTabs"
    [document_buttons_chico]="document_buttons_chico" [showBrokerExcludeTab]="showBrokerExcludeTab"></app-tabs-form>

  <div class="card w-100 form-right">

    <div class="back">
      <h2 *ngIf="!draft">{{ "forms.names.addcampaign" | translate }}</h2>
      <div *ngIf="draft" class="div-title">

        <h2>
          {{ title }}

        </h2>
      </div>
      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>


    <div class="card-body">
      <div class="row">
        <div class="form">
          <form [formGroup]="form">
            <div [hidden]="activeForm !== 'general'">
                <app-general-form [campaignData]="campaignData" [campaignPreData]="campaignPreData" [ladata]="ladata" [hasExcludedBrokers]="hasExcludedBrokers"
                  (brokerSelected)="onBrokerSelected($event)">
                </app-general-form>
            </div>

            <div [hidden]="activeForm !== 'vehicle'">
              <app-vehicle-form [campaignData]="campaignData" [ladata]="ladata"></app-vehicle-form>
            </div>

            <div [hidden]="activeForm !== 'currency'">
              <app-contract-form [campaignData]="campaignData" [ladata]="ladata"
                (matrixDimensionsChanged)="onMatrixDimensionsChanged($event)"
                (matrixValuesChanged)="onMatrixValuesChanged()"
                (ivaToggled)="onIvaToggled($event)">
              </app-contract-form>
            </div>

            <div [hidden]="activeForm !== 'matrix_by_type'">
              <label class="form-label">{{ "inputs.matrix_price_by_type" | translate }}</label>
              <div class="mb-3">
                <span class="text-secondary">
                  {{ "forms.labels.matrix_price_by_type_info" | translate }}
                </span>
              </div>
              <app-triple-matrix
                [campaignData]="campaignData"
                [ivaEnabled]="contractFormComponent?.ivaEnabled ?? true">
              </app-triple-matrix>
            </div>
            <div [hidden]="!['doc-campaign'].includes(activeForm)" class="accountData">
                <app-form-add-document  [campaignData]="campaignData"
                  [activeForm]="activeForm" [ladata]="ladata" [btn_submit]="false"
                  (filesArrayChanged)="actualizarEstadoArchivos($event)" (goDocs)="goDocs()"
                  (formSubmit)="refrescar()"></app-form-add-document>
              </div>
            <div [hidden]="activeForm !== 'timeline'">
             <app-timeline [campaign_reference]="campaign_reference"></app-timeline>
            </div>

            <div [hidden]="activeForm !== 'broker_exclude'" *ngIf="showBrokerExcludeTab">
              <app-broker-form [campaignData]="campaignData" [isEditMode]="isEditMode" [excludedBrokersExternal]="excludedBrokers"
                [hasBrokerPrincipal]="!showBrokerExcludeTab"
                (excludedBrokersChanged)="onExcludedBrokersChanged($event)">
              </app-broker-form>
            </div>
          </form>
        </div>
      </div>

      <div class="div-form"></div>

      <div class="btn-send d-flex align-items-center justify-content-end w-100 ml-4">

          <button *ngIf="!draft" type="submit" class="btn btn-primary btn-primary-form" (click)="onSubmit()">
            <span>
              {{ "buttons.createdraft" | translate }}
            </span>
          </button>
          <button *ngIf="draft" type="submit" class="btn btn-primary btn-primary-form"
            (click)="onSubmitDraft()">
            <span>
              {{ "buttons.update_campaign" | translate }}
            </span>
          </button>

      </div>
    </div>
  </div>
</div>
